import './OTPForm.css';
import React, { useState, useRef, useEffect } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get } from '../../utils';
import { OTP_BASE_TIMER, STEPS } from './AccountAuthorization';
import { loaderToggle, setUserCookie } from '../../utils/setUserCookie';
import Recaptcha from './components/Recaptcha';
import GoBackBtn from './components/GoBackBtn';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
const OTPForm = _ref => {
  let {
    fields,
    params,
    getActiveStep,
    userEmail,
    bmCookies,
    setGlobalLoader,
    timer,
    requestEvisaToken,
    getEvisaToken,
    eventsAnalytics
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const buttonText = get(fields, 'data.datasource.loginOTPButtonLabel.jss.value');
  const goBackLabel = mapDictionary.get('goBackLabel') || '';
  const seconds = mapDictionary.get('seconds') || '';
  const second = mapDictionary.get('second') || '';
  const resendOTPLabel = mapDictionary.get('resendOTPLabel') || '';
  const enterOTPLabel = mapDictionary.get('enterOTP') || '';
  const redirectHome = get(fields, 'data.contextItem.redirectPage.jss.value.href');
  const [formResponseError, setFormResponseError] = useState('');
  const [otpArray, setOtpArray] = useState(['', '', '', '', '', '']);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [timeLeft, setTimeLeft] = useState(timer);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const inputRefs = useRef([]);
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  const formErrorInvalidGrant = mapDictionary.get('FormSubmitIncorrent');
  const formErrorNetworOrApiIssue = mapDictionary.get('LoginApiFailError');
  const formErrorUserLocked = mapDictionary.get('ApiErrorUserLockedOutTooManyLoginAttempts');
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  const [recaptchaError, setRecaptchaError] = useState('');
  const recaptchaRef = useRef(null);
  const recaptchErrorMessage = mapDictionary.get('FieldErrorRequierdRecaptcha');
  let referBack = false;
  let referrer = '/';
  let urlParams = null;
  if (canUseDOM) {
    urlParams = qsToObject(window.location.href);
    if (urlParams.redirect_url && urlParams.redirect_url.length) {
      referBack = true;
      referrer = urlParams.redirect_url;
    }
  }
  let homeURL;
  if (canUseDOM) {
    homeURL = window.location.origin;
    homeURL += redirectHome;
  }
  useEffect(() => {
    let timerLeft;
    if (timeLeft > 0) {
      timerLeft = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
    } else {
      setIsResendDisabled(false);
    }
    return () => clearTimeout(timerLeft);
  }, [timeLeft]);
  const handleChange = (index, value) => {
    setFormResponseError('');

    // Only allow single digit
    if (value.length > 1) return;

    // Only allow numbers
    if (value && !/^\d$/.test(value)) return;
    const newOtp = [...otpArray];
    newOtp[index] = value;
    setOtpArray(newOtp);

    // Auto-focus next input
    if (value && index < 5) {
      const nextInput = inputRefs.current[index + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
  };
  const handleKeyDown = (index, e) => {
    setFormResponseError('');
    if (e.key === 'Backspace') {
      if (!otpArray[index] && index > 0) {
        // If current input is empty, focus previous input
        const prevInput = inputRefs.current[index - 1];
        if (prevInput) {
          prevInput.focus();
        }
      } else {
        // Clear current input
        const newOtp = [...otpArray];
        newOtp[index] = '';
        setOtpArray(newOtp);
      }
    } else if (e.key === 'ArrowLeft' && index > 0) {
      const prevInput = inputRefs.current[index - 1];
      if (prevInput) {
        prevInput.focus();
      }
    } else if (e.key === 'ArrowRight' && index < 5) {
      const nextInput = inputRefs.current[index + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
  };
  const handlePaste = e => {
    setFormResponseError('');
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (pastedData.length === 6) {
      const newOtp = pastedData.split('');
      setOtpArray(newOtp);
      const lastInput = inputRefs.current[5];
      if (lastInput) {
        lastInput.focus();
      }
    }
  };
  const successFunction = platformName => {
    // tealiumClickFunc(tealiumMergeClickData(loginSuccess, { ...params, email: userEmail }), platformName);
    if (canUseDOM) {
      if (requestEvisaToken) {
        console.log('getEvisaToken oto success');
        return;
      }
      if (referBack) {
        window.location = referrer;
      } else {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['loginSuccess'], params), 'email');
        window.location.href = homeURL;
      }
    }
  };
  const verifyOTP = async () => {
    let formdata = new FormData();
    let recaptchaToken;
    if (recaptchaRef.current) {
      recaptchaToken = await recaptchaRef.current.getRecaptchaToken();
    }
    if (!recaptchaToken) {
      setRecaptchaError(recaptchErrorMessage);
    } else {
      setRecaptchaError('');
    }
    formdata.append('grant_type', 'otp');
    formdata.append('client_id', clientId);
    formdata.append('client_secret', clientSecret);
    formdata.append('scope', 'api.read    IdentityServerApi   offline_access');
    formdata.append('email', userEmail);
    formdata.append('otp', otpArray.join(''));
    formdata.append('g-recaptcha-response', recaptchaToken);
    let myHeaders = new Headers();
    if (bmCookies._abck || bmCookies.ak_bmsc || bmCookies.bm_mi || bmCookies.bm_sv || bmCookies.bm_sz) {
      myHeaders.append('Cookie', `
              ${bmCookies._abck ? `_abck=${bmCookies._abck}; ` : ''}
              ${bmCookies.ak_bmsc ? `ak_bmsc=${bmCookies.ak_bmsc}; ` : ''}
              ${bmCookies.bm_mi ? `bm_mi=${bmCookies.bm_mi}; ` : ''}
              ${bmCookies.bm_sv ? `bm_sv=${bmCookies.bm_sv}; ` : ''}
              ${bmCookies.bm_sz ? `bm_sz=${bmCookies.bm_sz}; ` : ''}
          `);
    }
    let requestOptions = {
      credentials: 'include',
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: myHeaders
    };
    let statusCode = 0;
    await fetch(`${identityGlobal}/connect/token`, requestOptions).then(response => {
      statusCode = response.status;
      return response.text();
    }).then(result => {
      loaderToggle(false, setDisableSubmit);
      setGlobalLoader(false);
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 400) {
        const error = responseObj.error;
        if (error === 'invalid_grant') {
          if (responseObj.error_description === 'locked_out') {
            throw Error(formErrorUserLocked);
          } else {
            throw Error(formErrorInvalidGrant);
          }
        } else if (error === 'invalid_client') {
          throw Error(formErrorNetworOrApiIssue);
        } else {
          throw Error(formErrorNetworOrApiIssue);
        }
      } else if (statusCode === 200) {
        if (responseObj.access_token) {
          setUserCookie(responseObj);
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['signinCTAsAnalytics'], params), buttonText);
          if (requestEvisaToken) {
            getEvisaToken(responseObj.access_token);
          } else {
            successFunction('Default');
          }
        }
      } else {
        throw Error(formErrorNetworOrApiIssue);
      }
    }).catch(error => {
      loaderToggle(false, setDisableSubmit);
      setGlobalLoader(false);
      if (statusCode === 0) {
        setFormResponseError(formErrorNetworOrApiIssue);
      } else {
        setFormResponseError(error.message);
      }
    });
  };
  const handleResend = async () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['signinCTAsAnalytics'], params), resendOTPLabel);
    setTimeLeft(OTP_BASE_TIMER);
    setIsResendDisabled(true);
    setOtpArray(['', '', '', '', '', '']);
    const firstInput = inputRefs.current[0];
    if (firstInput) {
      firstInput.focus();
    }
    let recaptchaToken;
    if (recaptchaRef.current) {
      recaptchaToken = await recaptchaRef.current.getRecaptchaToken();
    }
    if (!recaptchaToken) {
      setRecaptchaError(recaptchErrorMessage);
    } else {
      setRecaptchaError('');
    }
    let raw = {
      client_id: clientId,
      'g-recaptcha-response': recaptchaToken,
      email: userEmail
    };
    let myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    if (bmCookies._abck || bmCookies.ak_bmsc || bmCookies.bm_mi || bmCookies.bm_sv || bmCookies.bm_sz) {
      myHeaders.append('Cookie', `
                ${bmCookies._abck ? `_abck=${bmCookies._abck}; ` : ''}
                ${bmCookies.ak_bmsc ? `ak_bmsc=${bmCookies.ak_bmsc}; ` : ''}
                ${bmCookies.bm_mi ? `bm_mi=${bmCookies.bm_mi}; ` : ''}
                ${bmCookies.bm_sv ? `bm_sv=${bmCookies.bm_sv}; ` : ''}
                ${bmCookies.bm_sz ? `bm_sz=${bmCookies.bm_sz}; ` : ''}
            `);
    }
    let requestOptions = {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(raw),
      redirect: 'follow',
      headers: myHeaders
    };
    let statusCode = 0;
    loaderToggle(true, setDisableSubmit);
    setGlobalLoader(true);
    await fetch(`${identityGlobal}/api/account/requestOtp`, requestOptions).then(response => {
      statusCode = response.status;
      return response.text();
    }).then(result => {
      loaderToggle(false, setDisableSubmit);
      setGlobalLoader(false);
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 400) {
        throw Error(formErrorNetworOrApiIssue);
      } else if (statusCode === 200) {
        // setUserCookie(responseObj);
        // successFunction('Default');
      } else {
        throw Error(formErrorNetworOrApiIssue);
      }
    }).catch(error => {
      loaderToggle(false, setDisableSubmit);
      setGlobalLoader(false);
      if (statusCode === 0) {
        setFormResponseError(formErrorNetworOrApiIssue);
      } else {
        setFormResponseError(error.message);
      }
    });
  };
  const formatTime = seconds => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  const formSubmit = event => {
    setFormResponseError('');
    if (otpArray.join('').length === 6) {
      loaderToggle(true, setDisableSubmit);
      setGlobalLoader(true);
      verifyOTP();
    }
    event.preventDefault();
  };
  const stepBack = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['signinCTAsAnalytics'], params), goBackLabel);
    getActiveStep(STEPS.STEP6);
  };
  const isSubmitOtpDisabled = otpArray.join('').length !== 6 || disableSubmit;
  const OTPBlock = /*#__PURE__*/React.createElement("div", {
    className: ` otp-form ${rtl ? rtlStylesOTP : ltrStylesOTP} ${commonStylesOTP}`
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("label", {
    className: `form-label`
  }, enterOTPLabel, /*#__PURE__*/React.createElement("strong", null, "*")), /*#__PURE__*/React.createElement("form", {
    onSubmit: event => formSubmit(event),
    noValidate: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "otp-inputs-block"
  }, otpArray.map((digit, index) => /*#__PURE__*/React.createElement("input", {
    key: index,
    className: `otp-input ${formResponseError ? 'otp-input--error' : ''}`,
    ref: el => inputRefs.current[index] = el,
    type: "password",
    maxLength: 1,
    value: digit,
    onChange: e => handleChange(index, e.target.value),
    onKeyDown: e => handleKeyDown(index, e),
    onPaste: handlePaste,
    "aria-label": `OTP digit ${index + 1}`
  }))), formResponseError && formResponseError.length ? /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, formResponseError) : null, /*#__PURE__*/React.createElement("button", {
    disabled: isSubmitOtpDisabled,
    className: "btn btn-primary"
  }, buttonText))), /*#__PURE__*/React.createElement("div", {
    className: "otp-form-controls"
  }, /*#__PURE__*/React.createElement(GoBackBtn, {
    label: goBackLabel,
    handleClick: stepBack
  }), /*#__PURE__*/React.createElement("div", {
    className: "otp-form-controls__timer-block"
  }, /*#__PURE__*/React.createElement("span", {
    className: "timer"
  }, formatTime(timeLeft), " ", timeLeft > 9 ? seconds : second), /*#__PURE__*/React.createElement("button", {
    onClick: handleResend,
    disabled: isResendDisabled,
    className: "btn btn-tertiary"
  }, resendOTPLabel))), /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaError,
    ref: recaptchaRef
  }));
  return OTPBlock;
};
const commonStylesOTP = "c186tccq";
const ltrStylesOTP = "l1lngf56";
const rtlStylesOTP = "rumvte0";
export default OTPForm;